import { render, staticRenderFns } from "./CopyIcon.vue?vue&type=template&id=77ba9bc2&"
import script from "./CopyIcon.vue?vue&type=script&lang=ts&"
export * from "./CopyIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports